/* Content for the CANTO Connect 2027 & AGM Call for Participation page.
   Rendered by views/subviews/CallForParticipation.js, the same component the
   Annual Conference call uses — see data/callForParticipation.js for that one.

   STILL TO COME FROM THE CLIENT: the Google Form URL and the PDF. Until each
   one is filled in below, its button renders in a disabled "coming soon" state
   instead of linking nowhere. */

const data = {
  eyebrow: 'CANTO Connect 2027 & AGM',
  title: 'Call for Participation',
  tagline: 'Shape the Digital Future of the Caribbean',
  pdfTitle: 'Download the CANTO Connect & AGM 2027 Call for Participation',
  submitLabel: 'Submit Now',

  // Dates are baked into banner.png as well; update both together.
  submissionsOpen: '1 October 2026',
  submissionsClose: '1 November 2026',

  // Awaiting the client — leaving these null keeps both buttons disabled.
  formUrl: null,
  pdfUrl: null,

  bannerUrl: '/assets/canto_connect_cfp/banner.png',
  // Scenery-only slice of the banner — the full artwork's headline would
  // ghost through the footer band's overlay.
  footerBgUrl: '/assets/canto_connect_cfp/footer_bg.png',

  // The Panama artwork alternates teal and red accents.
  alternateAccent: true,

  intro: [
    "CANTO Connect brings together the Caribbean's telecommunications operators, technology vendors, governments, regulators, investors, and innovators. In 2027 we are using a Call for Participation rather than a traditional Call for Papers. This is a deliberate choice. We want practitioners, executives, and policymakers who are building the region's digital future, not only researchers.",
    'This is an industry forum, not an academic conference. There are no academic prerequisites. If you have a real story, a working solution, a policy insight, an investment thesis, or a product that serves the Caribbean, we want to hear from you.',
  ],

  audiences: [
    { icon: 'executives', label: 'Executives' },
    { icon: 'policymakers', label: 'Policymakers' },
    { icon: 'technology', label: 'Technology Leaders' },
    { icon: 'investors', label: 'Investors' },
    { icon: 'rocket', label: 'Entrepreneurs' },
    { icon: 'innovators', label: 'Innovators' },
  ],

  themes: [
    'AI and Digital Transformation',
    '5G, LEO and Next-Gen Networks',
    'Cybersecurity and Digital Trust',
    'Digital Finance, Fintech and Payments',
    'Regulatory Innovation and Spectrum',
    'Investment and Infrastructure Finance',
    'Smart Cities, IoT and Energy',
    'Digital Health, Education and Impact',
    'Climate-Resilient Connectivity',
    'Future of Work and Human Capital',
    'Data Economy and AI Governance',
    'Women in Tech and Leadership',
  ],

  formats: [
    {
      icon: 'spotlight',
      label: 'Spotlight Showcase',
      duration: '15 min',
      desc: 'A solo presentation to the full audience. Ideal for product launches, case studies, and announcements.',
    },
    {
      icon: 'keynote',
      label: 'Keynote within Panel',
      duration: '20–30 min',
      desc: 'Be the featured voice within a moderated panel discussion.',
    },
    {
      icon: 'panelist',
      label: 'Panelist Position',
      duration: '45–60 min',
      desc: 'Join a multi-stakeholder panel of 4 to 5 experts.',
    },
    {
      icon: 'dialogue',
      label: 'CEO / Executive Dialogue',
      duration: '30 min',
      desc: 'An intimate fireside chat. By invitation or through sponsorship.',
    },
    {
      icon: 'workshop',
      label: 'Workshop / Summit Session',
      duration: '90–120 min',
      desc: 'A fully branded deep-dive session that you curate.',
    },
    {
      icon: 'pitch',
      label: 'Startup Pitch',
      duration: '5–10 min',
      desc: 'Pitch your innovation in the Innovation Pavilion.',
    },
  ],

  keyDates: [
    { date: '1 October 2026', label: 'Call for Participation opens' },
    { date: '1 November 2026', label: 'Submissions close' },
    { date: '30 November 2026', label: 'Selection complete' },
    { date: '7 December 2026', label: 'Participants notified' },
    { date: '31 January – 2 February 2027', label: 'CANTO Connect and AGM' },
  ],

  contact: {
    name: 'Andrea Lewis-Francis',
    role: 'Business Support Officer, CANTO',
    email: 'alewis@canto.org',
  },
};

export default data;
